import { BehaviorSubject, from, Observable, of } from 'rxjs';
import { catchError, filter, mergeMap } from 'rxjs/operators';
import { Dependencies } from '../../../../configurations/dependencies/dependencies.interface';
import { Action, AnyAction } from '../../../state/action.type';
import { AppState } from '../../../state/app.state';
import {
  restoreAuthFailure,
  restoreAuthSuccess,
} from '../../../state/authentication/authentication.action';
import {
  RestoreAuthFromStorage,
  RESTORE_AUTH_FROM_STORAGE,
} from '../../../state/authentication/authentication.action.type';
import { getUserProfile } from '../../../state/user/user.action';
import { AUTH_USECASE_ERROR_MESSAGES } from '../../errors/usecases.errorMessages/authenticationUsecase.error.messages';
import {
  clearAuthToken,
  getStoredAuthToken,
} from '../../utils/authStorage.utils';

export const restoreAuthUsecase = (
  action$: Observable<Action>,
  _state$: BehaviorSubject<AppState>,
  dependencies: Dependencies,
): Observable<Action> =>
  action$.pipe(
    filter(
      (action: AnyAction): action is RestoreAuthFromStorage =>
        action.type === RESTORE_AUTH_FROM_STORAGE,
    ),
    mergeMap(() => {
      const storedToken = getStoredAuthToken();

      if (!storedToken) {
        console.log('No stored token found');
        return of(restoreAuthFailure('No stored token'));
      }

      console.log('Found stored token, verifying...');

      // Verify the stored token with the backend
      return from(
        dependencies.backendAuthenticatorGateway.verifyToken(storedToken),
      ).pipe(
        mergeMap(() => {
          console.log('Stored token verified successfully');
          // Token is valid, restore auth state and get user profile
          return [
            restoreAuthSuccess(storedToken),
            getUserProfile({
              token: storedToken,
              retry: 2,
            }),
          ];
        }),
        catchError((error) => {
          console.warn('Stored token verification failed:', error.message);
          // Token is invalid, clear it and fail restoration
          clearAuthToken();
          return of(
            restoreAuthFailure(AUTH_USECASE_ERROR_MESSAGES.SESSION_EXPIRED),
          );
        }),
      );
    }),
  );
